import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d54f506e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { value: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.0848 8.41976C15.4102 8.09435 15.4101 7.56668 15.0848 7.24124C14.7594 6.91582 14.2317 6.91581 13.9063 7.24124L9.99846 11.1491L6.09061 7.24125L6.02732 7.1837C5.70001 6.91691 5.21714 6.93621 4.9121 7.24125C4.60717 7.54629 4.58778 8.02919 4.85456 8.35646L4.9121 8.41976L9.23254 12.7402C9.65554 13.1631 10.3413 13.163 10.7644 12.7402L15.0848 8.41976Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-select__popper--arrow" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "frisbuy-select__option-text" }
const _hoisted_9 = {
  key: 0,
  class: "frisbuy-select__option-check",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import { HTMLAttributes, onMounted, ref, watch } from "vue";
import vClickOutside from "@/common/directives/vClickOutside";

type TSelectOption = {
  value: string | number | symbol | undefined;
  sort?: "asc" | "desc";
  text: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FrSelect',
  props: {
    modelValue: { default: () => {
      return { value: undefined, text: "" };
    } },
    options: {},
    defaultOption: {},
    customStyle: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

onMounted(() => {
  if (props.defaultOption) {
    setDefaultOption(props.defaultOption);
  }
});

const selectOptions = ref();
const isSelectMenuOpen = ref(false);

function openSelectMenu() {
  if (props.disabled) {
    return;
  }

  isSelectMenuOpen.value = true;

  selectOptions?.value.focus();
}

function closeSelectMenu() {
  isSelectMenuOpen.value = false;
}

function selectMenuClickHandler() {
  if (props.disabled) {
    return;
  }

  if (isSelectMenuOpen.value) {
    closeSelectMenu();
  } else {
    /* NOTE:
      vClickOutside without this timeout is called immediately
      after openSelectMenu via select-button's @click
    */
    setTimeout(() => {
      openSelectMenu();
    });
  }
}

function setDefaultOption(option: TSelectOption) {
  selectedOption.value = option;
}

const selectedOption = ref<TSelectOption>(props.modelValue);
function selectOption(option: TSelectOption) {
  if (props.disabled) {
    return;
  }

  emit("update:modelValue", option);

  selectedOption.value = option;
  closeSelectMenu();
}

watch(
  () => props.modelValue,
  (value) => {
    selectedOption.value = value;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frisbuy-select",
    style: _normalizeStyle(_ctx.customStyle)
  }, [
    (isSelectMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "frisbuy-select__backdrop",
          onClick: closeSelectMenu
        }))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      disabled: props.disabled,
      class: _normalizeClass(["frisbuy-select__select-button", { 'frisbuy-select__select-button--is-open': isSelectMenuOpen.value }]),
      onClick: selectMenuClickHandler
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(selectedOption.value.text), 1),
      _hoisted_3
    ], 10, _hoisted_1),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["frisbuy-select__options", { '--is-closed': !isSelectMenuOpen.value }]),
      ref_key: "selectOptions",
      ref: selectOptions,
      tabindex: "-1"
    }, [
      _createElementVNode("button", {
        class: "frisbuy-select__mobile-close",
        type: "button",
        onClick: closeSelectMenu
      }, _hoisted_5),
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${option.value}-${option.sort || ''}`,
          class: _normalizeClass(["frisbuy-select__option", {
          'frisbuy-select__option--disabled': props.disabled,
          'frisbuy-select__option--selected':
            selectedOption.value?.value === option.value &&
            selectedOption.value?.sort === option.sort,
        }]),
          onClick: () => selectOption(option)
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(option.text), 1),
          (
            selectedOption.value?.value === option.value &&
            selectedOption.value?.sort === option.sort
          )
            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true)
        ], 10, _hoisted_7))
      }), 128))
    ], 2)), [
      [_unref(vClickOutside), closeSelectMenu]
    ])
  ], 4))
}
}

})